import React, { useState } from 'react'
import Navbars from '../Utility/Navbars'
import Footer from '../Home/Footer'
import Training from '../Images/Icons/training.png'
import Inclusive from '../Images/Icons/INC.png'
import Compt from '../Images/Icons/compt.png'
import Growth from '../Images/Icons/growth.svg'
import swal from 'sweetalert';

function Career() {
    const [formData, setFormData] = useState({
        candidate_name: '',
        candidate_email: '',
        phone_number: '',
        description: '',
        cv: null
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validate = () => {
        const newErrors = {};
        if (!formData.candidate_name.trim()) newErrors.candidate_name = "Full name is required";
        if (!formData.candidate_email.trim() || !/\S+@\S+\.\S+/.test(formData.candidate_email)) newErrors.candidate_email = "Valid email required";
        if (!formData.phone_number.trim() || formData.phone_number.length < 10) newErrors.phone_number = "Valid phone number required";
        if (!formData.description.trim()) newErrors.description = "Description is required";
        if (!formData.cv) newErrors.cv = "Resume is required";
        return newErrors;
    }

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: files ? files[0] : value
        }));
    }

    const handleSubmit = async (e) => {
        console.log("40");
        e.preventDefault();
        console.log("42");
        const validationErrors = validate();
        console.log(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        console.log("50");

        setErrors({});
        setIsSubmitting(true);

        const submissionData = new FormData();
        submissionData.append('candidate_name', formData.candidate_name);
        submissionData.append('candidate_email', formData.candidate_email);
        submissionData.append('phone_number', formData.phone_number);
        submissionData.append('description', formData.description);
        submissionData.append('cv', formData.cv);
        submissionData.append('source', "StarGoldCompany");

        try {
            const response = await fetch('https://backend.aslikahani.com/purity/v1/career/submit', {
                method: 'POST',
                body: submissionData
            });

            if (response.ok) {
                // alert("Application submitted successfully!");
                setFormData({
                    candidate_name: '',
                    candidate_email: '',
                    phone_number: '',
                    description: '',
                    cv: null
                });
                swal({
                    title: "Query Submitted",
                    text: "Team will get back to you shortly",
                    icon: "success"
                })
            } else {
                // alert("Failed to submit application.");
                swal({
                    title: "Failed!!!",
                    text: "Please check your details and try again",
                    icon: "error"
                })
            }
        } catch (error) {
            console.error(error);
            alert("An error occurred. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    }
    return (
        <>
            <Navbars />
            <div className='inner-pages'>
                <section className="about-content career-head">
                    <div className='container'>
                        <div class="shop-by-hero-bg">
                            <div class="blob blob-five blob1 solid-blob"></div>
                            <div class="blob blob-four blob2 solid-blob"></div>
                        </div>
                        <div className='abt-cont'>
                            <h4>Join Our Team at SriStar Gold Company - <span>A Leading Gold Buying Company</span></h4>
                            <p>At SriStar Gold Company, we are committed to providing our clients with the highest level of service and the best value for their gold. As a leading gold buying company, we pride ourselves on our integrity, expertise, and commitment to customer satisfaction. Our team is the backbone of our success, and we are always looking to welcome new members who share our passion for excellence and our dedication to the precious metals industry.</p>

                        </div>
                    </div>
                </section>
                <section className='services-section'>
                    <div className='container'>
                        <div className='services-container careerimg'>
                            <div className='sub-hading'>
                                <h2 className='section-sub-heading'>Why Work with Us</h2>
                            </div>
                            <div className='srv-grid-cont'>
                                <div className='srv-gird-content'>
                                    <div className='src-ico'>
                                        <img className='img-fluid' alt='img-icon-service' src={Growth} />
                                    </div>
                                    <div className='srv-text'>
                                        <h3> Growth Opportunities </h3>
                                        <p>We believe in nurturing talent and providing our employees with the opportunities to grow professionally. Whether you are just starting your career or are an experienced professional, SriStar Gold Company offers a dynamic and supportive environment where you can achieve your career aspirations.</p>
                                    </div>
                                </div>

                                <div className='srv-gird-content'>
                                    <div className='src-ico'>
                                        <img className='img-fluid' alt='img-icon-service' src={Inclusive} />
                                    </div>
                                    <div className='srv-text'>
                                        <h3>Inclusive Culture</h3>
                                        <p>Our team is our most valuable asset, and we strive to create a diverse and inclusive workplace. We celebrate differences and believe that a variety of perspectives leads to better decision-making and a more enjoyable work environment.</p>
                                    </div>
                                </div>
                                <div className='srv-gird-content'>
                                    <div className='src-ico'>
                                        <img className='img-fluid' alt='img-icon-service' src={Training} />
                                    </div>
                                    <div className='srv-text'>
                                        <h3> Training and Development </h3>
                                        <p>At SriStar Gold Company, we are committed to the ongoing development of our staff. We offer comprehensive training programs and professional development opportunities that equip our team with the knowledge and skills to excel in their roles.</p>
                                    </div>
                                </div>

                                <div className='srv-gird-content'>
                                    <div className='src-ico'>
                                        <img className='img-fluid' alt='img-icon-service' src={Compt} />
                                    </div>
                                    <div className='srv-text'>
                                        <h3>Competitive Compensation </h3>
                                        <p>We offer competitive salaries, performance bonuses, and a comprehensive benefits package that includes health insurance, retirement plans, and paid time off. </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className='partners-form'>
                        <div className='container'>
                            <div className="sub-hading"><h2>Apply Now<br /><strong>Submit your details</strong></h2></div>
                            <div className='careerForm'>
                                <div className='row'>
                                    <div className='col-md-8 mx-auto'>
                                        <form onSubmit={handleSubmit}>
                                            <div className='row'>
                                                <div className="col-md-6 form-group">
                                                    <div className="form-input">
                                                        <label className='label-partners'>Full Name <span>*</span></label>
                                                        <input
                                                            type="text"
                                                            name="candidate_name"
                                                            value={formData.candidate_name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        {errors.candidate_name && <small className="text-danger">{errors.candidate_name}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <div className="form-input">
                                                        <label className='label-partners'>Email <span>*</span></label>
                                                        <input
                                                            type="email"
                                                            name="candidate_email"
                                                            value={formData.candidate_email}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        {errors.candidate_email && <small className="text-danger">{errors.candidate_email}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <div className="form-input">
                                                        <label className='label-partners'>Mobile <span>*</span></label>
                                                        <input
                                                            type="tel"
                                                            name="phone_number"
                                                            value={formData.phone_number}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        {errors.phone_number && <small className="text-danger">{errors.phone_number}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <div className="form-input fileType">
                                                        <label className='label-partners'>Upload Resume <span>*</span></label>
                                                        <input
                                                            type="file"
                                                            name="cv"
                                                            accept=".pdf,.doc,.docx"
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        {errors.cv && <small className="text-danger">{errors.cv}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-12 form-group">
                                                    <div className="form-input textArd">
                                                        <label className='label-partners'>Why are you a good fit for the organization? <span>*</span></label>
                                                        <textarea
                                                            name="description"
                                                            value={formData.description}
                                                            onChange={handleChange}
                                                            required
                                                        ></textarea>
                                                        {errors.description && <small className="text-danger">{errors.description}</small>}
                                                    </div>
                                                </div>

                                                <div className='col-md-12'>
                                                    <div className='form-submit'>
                                                        <button type="submit" disabled={isSubmitting}>
                                                            {isSubmitting ? 'Submitting...' : 'Submit'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='mid-section'>
                    <div className='container'>
                        <div className='how-to-apply'>
                            <div className='sub-hading'>
                                <h2 className='section-sub-heading'>How to <span>Apply</span></h2>
                            </div>
                            <p>If you're interested in pursuing a career with SriStar Gold Company, we would love to hear from you. Please visit our website at www.stargoldcompany.com to view detailed job descriptions and submit your application online. Include your resume, cover letter, and any relevant certifications or portfolios.</p>
                            <p>Join us at SriStar Gold Company and be a part of a leading gold buying company that values integrity, excellence, and a commitment to our clients. We look forward to welcoming you to our team!</p>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}

export default Career